import { z } from 'zod';

export const ScenarioTimelineSchema = z.object({
    id: z.string().optional(),
    time: z.string().min(1),
    phase: z.string().min(1),
    event: z.string().optional(),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateScenarioTimelineSchema = ScenarioTimelineSchema.omit({ id: true });
export const UpdateScenarioTimelineSchema = ScenarioTimelineSchema.partial();
